import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function Hamburger(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path d="M0.286,3.607c-0,-0.922 0.757,-1.679 1.678,-1.679l20.143,0c0.921,0 1.679,0.757 1.679,1.679c-0,0.921 -0.758,1.679 -1.679,1.679l-20.143,-0c-0.921,-0 -1.678,-0.758 -1.678,-1.679Zm-0,8.393c-0,-0.922 0.757,-1.679 1.678,-1.679l20.143,0c0.921,0 1.679,0.757 1.679,1.679c-0,0.921 -0.758,1.678 -1.679,1.678l-20.143,0c-0.921,0 -1.678,-0.757 -1.678,-1.678Zm-0,8.393c-0,-0.922 0.757,-1.679 1.678,-1.679l20.143,0c0.921,0 1.679,0.757 1.679,1.679c-0,0.921 -0.758,1.678 -1.679,1.678l-20.143,0c-0.921,0 -1.678,-0.757 -1.678,-1.678Z" />
    </IconWrapper>
  );
}
